// extracted by mini-css-extract-plugin
export var container = "_h7-0";
export var content = "_h7-3";
export var customerTitle = "_h7-4";
export var empty = "_h7-5";
export var gray = "_h7-6";
export var header = "_h7-7";
export var info = "_h7-8";
export var loading = "_h7-2";
export var loadingCard = "_h7-9";
export var oneLine = "_h7-a";
export var personName = "_h7-e";
export var pillContainer = "_h7-b";
export var selected = "_h7-1";
export var text = "_h7-c";
export var twoLines = "_h7-d";
export var unread = "_h7-f";
export var unreadIndicator = "_h7-g";